import type React from "react";
import { CustomCheckbox } from "~/components/ui/check_Box";
import styles from "../../index.module.scss";
import type { BooleanFieldComponentProps } from "../../types";

const defaultNowLabels: Record<string, string> = {
  DATE: "レコード登録時の日付を初期値にする",
  DATETIME: "レコード登録時の日時を初期値にする",
  TIME: "レコード登録時の時刻を初期値にする",
};

const typesWithUnique = new Set(["DATE", "DATETIME"]);

const DateOptions: React.FC<BooleanFieldComponentProps & { fieldType?: string }> = ({
  options,
  handleBooleanOptionChange,
  isReadOnly,
  fieldType = "DATE",
}) => {
  const dateOptions = [
    { key: "defaultNowValue", label: defaultNowLabels[fieldType] ?? defaultNowLabels["DATE"] },
    ...(typesWithUnique.has(fieldType) ? [{ key: "unique", label: "値の重複を禁止する" }] : []),
    { key: "required", label: "必須項目にする" },
    { key: "noLabel", label: "フィールド名を表示しない" },
  ];

  return (
    <>
      {/* チェックボックスオプション */}
      {dateOptions.map((option) => (
        <div key={option.key} className={styles["form-group"]}>
          <CustomCheckbox
            label={option.label ?? ""}
            checked={options[option.key] || false}
            onChange={(value) => handleBooleanOptionChange(option.key, value)}
            disabled={isReadOnly || false}
          />
        </div>
      ))}
    </>
  );
};

export default DateOptions;
